<template>
    <a-modal
        centered
        :visible="visible"
        title="生成订单"
        @ok="on_submit"
        @cancel="cancel"
        :confirmLoading="submitting"
        :width="540"
        :after-close="after_close"
    >
        <a-form-model :model="form" ref="order-create" :rules="rules">
            <a-form-model-item label="商标成本价格" prop="price">
                <a-input v-model="form.price"></a-input>
            </a-form-model-item>

            <a-row :gutter="18">
                <a-col :span="12">
                    <a-form-model-item label="买家首付款" prop="amount_deposit">
                        <a-input v-model="form.amount_deposit"></a-input>
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="卖家首付款" prop="amount_deposit_seller">
                        <a-input v-model="form.amount_deposit_seller"></a-input>
                    </a-form-model-item>
                </a-col>
            </a-row>

            <a-row :gutter="18">
                <a-col :span="12">
                    <a-form-model-item>
                        <a-checkbox v-model="form.is_include_notary">
                            是否包含公证
                        </a-checkbox>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-checkbox v-model="form.is_include_invoice">
                            是否包含发票
                        </a-checkbox>
                    </a-form-model-item> </a-col
                ><a-col :span="12">
                    <a-form-model-item>
                        <a-checkbox v-model="form.is_include_transfer">
                            是否包含转让费
                        </a-checkbox>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-checkbox v-model="form.is_include_license">
                            是否代办执照
                        </a-checkbox>
                    </a-form-model-item>
                </a-col>
            </a-row>

            <a-form-model-item label="服务费" extra="订单利润 = 商标价格 - 商标成本 - 服务费">
                <a-input v-model="form.amount_service"></a-input>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>
<script>
    let init_form = {
        price: null,
        amount_deposit_seller: null,
        amount_deposit: null,
        amount_service: null,
        is_include_invoice: false,
        is_include_license: false,
        is_include_notary: false,
        is_include_transfer: false,
    };
    export default {
        props: {
            visible: {
                default: false,
            },
            record: null,
            callback: null,
            mode: {
                default: "create",
            },
        },
        data() {
            return {
                submitting: false,
                loading_member: false,
                data_trademark: {},
                rules: {
                    member_id: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                    apply_no: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                    price: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                    amount_deposit_seller: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                    amount_deposit: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                },
                form: null,
            };
        },
        created() {
            this.form = JSON.parse(JSON.stringify(init_form));
            // this.load_group();
            // this.load_role();
        },
        watch: {
            visible(e) {
                if (e && this.record) {
                    this.form.order_no = this.record.order_no
                }
            },
        },
        methods: {
            cancel() {
                this.$emit("close");
            },
            on_submit() {
                this.$refs["order-create"].validate((valid) => {
                    if (valid) {
                        if (this.mode === "create") {
                            return this.on_create();
                        } else {
                            return this.on_edit();
                        }
                    } else {
                        this.$message.error("请检查并填写完需要录入的内容");
                        return false;
                    }
                });
            },
            on_create() {
                this.submitting = true;
                this.$http
                    .post("/order_trademark/prepare/generate", this.form)
                    .then((res) => {
                        if (res.success) {
                            this.cancel();
                            this.$message.success(res.message);
                            if (this.callback) {
                                this.callback();
                            }
                        } else {
                            this.$error({ title: "失败", centered: true, content: res.message });
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.submitting = false;
                    });
            },
            after_close() {
                this.$refs["order-create"].resetFields();

                this.form = JSON.parse(JSON.stringify(init_form));
            },
            on_read_trademark() {
                let apply_no = this.form.apply_no;
                if (!apply_no) {
                    return false;
                }

                this.$http
                    .get("/trademark/" + apply_no)
                    .then((res) => {
                        if (res.success) {
                            this.data_trademark = res.data;
                        } else {
                            this.$error({ title: "失败", centered: true, content: res.message });
                        }
                    })
                    .catch(() => {})
                    .then(() => {});
            },
        },
    };
</script>
